class OnLoad {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[]')
        if(!this.els.length > 0) {
            return
        }
        this.els.forEach(el => {
            switch(el.getAttribute('data-on-load')) {
                case 'class':
                    window.addEventListener('load', () => this.addClassOnLoad(el))
                    break
                case 'click':
                    let elAction = el.querySelector('[data-on-load-action]')
                    let elTick = el.querySelector('[data-on-load-tick]')
                    if(elTick) {
                        let tick = 5
                        let message = elTick.innerHTML
                        elTick.innerHTML = message.replace('%s', tick)
                        let int = setInterval(() => {
                            tick = Math.max(tick - 1, 0)
                            elTick.innerHTML = message.replace('%s', tick)
                            if(tick == 0) {
                                clearInterval(int)
                            }
                        }, 1000)
                    }
                    window.addEventListener('load', () => this.clickOnLoad(elAction, 5000))
                    break
                default:
                    break
            }
        })
    }
    addClassOnLoad(el) {
        el.classList.add('global-is-loaded')
    }
    clickOnLoad(el, timeout = false) {
        if(timeout) {
            setTimeout(() => el.click(), timeout)
        } else {
            el.click()
        }
    }
}

export default OnLoad